import React, { useState,useRef, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { GridExporter } from '@devexpress/dx-react-grid-export';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableGroupRow,
  Toolbar,
  SearchPanel,
  PagingPanel,
  ExportPanel
} from '@devexpress/dx-react-grid-material-ui';
import {
  GroupingState,
  IntegratedGrouping,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting
} from '@devexpress/dx-react-grid';
import saveAs from 'file-saver';
import 
{
  Button
} from '@mui/material';


export default function (props) {
  const {bindlist, headCells,filename} = props;
  const [sorting, setSorting] = useState([{ columnName: 'ID', direction: 'asc' }]);
  const exporterRef = useRef(null);
  const startExport = useCallback(() => {
    exporterRef.current.exportGrid();
  }, [exporterRef]);
  const onSave = (workbook) => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${filename }.xlsx`);
    });
  };
  return (
    <Paper>
      <Grid rows={bindlist} columns={headCells}>
      
        <SearchState defaultValue="" />
        <IntegratedFiltering />
        <SortingState
          sorting={sorting}
          onSortingChange={setSorting}
        />
        <IntegratedSorting />
        <PagingState defaultCurrentPage={0} pageSize={50} />
        <IntegratedPaging />
        <Table />
       
        <TableHeaderRow showSortingControls/>
       
        <Toolbar />
        <ExportPanel startExport={startExport} />
        <PagingPanel />
        <SearchPanel />
      </Grid>
      <GridExporter
        ref={exporterRef}
        rows={bindlist}
        columns={headCells}
        onSave={onSave}
      />
    </Paper>
  );
}
